import { useEffect } from "react";
import { router } from "@/app/router";
import { platform } from "@/platform";
import { ensurePushDevice } from "@/modules/sys/push/ensurePushDevice";
import { resolvePushTapPath } from "@/modules/sys/push/pushTap";
import { useAuth } from "@/shared/auth/AuthContext";

/**
 * After login, register this device and open the inbox route when a notification is tapped.
 * Tap never approves or completes the underlying task.
 */
export function NativePushBridge() {
  const { status, user, http } = useAuth();

  useEffect(() => {
    if (!platform.isNative || status !== "authenticated" || !user) return;
    const roles = user.roles;
    const unsubscribe = platform.push.subscribeOpen((open) => {
      const path = resolvePushTapPath(open, window.location.pathname, roles);
      if (!path || path === window.location.pathname) return;
      void router.navigate(path);
    });
    const pending = platform.push.takePendingOpen();
    if (pending) {
      const path = resolvePushTapPath(pending, window.location.pathname, roles);
      if (path && path !== window.location.pathname) void router.navigate(path);
    }
    return unsubscribe;
  }, [status, user]);

  useEffect(() => {
    if (!platform.isNative || status !== "authenticated") return;
    let cancelled = false;
    void ensurePushDevice(http).then((result) => {
      if (cancelled || result === "ok") return;
      console.warn("Native push registration", result);
    });
    return () => {
      cancelled = true;
    };
  }, [status, http]);

  return null;
}
